import { get } from "lodash";

export const getLastname = (values, path) =>
  String(get(values, path) || "").trim();

export const hasSameLastname = (values, path, sourcePath) => {
  const sourceLastname = getLastname(values, sourcePath).toLowerCase();
  return (
    !!sourceLastname &&
    getLastname(values, path).toLowerCase() === sourceLastname
  );
};
